export function cardURL(
  cardName: string,
  options: {
    id?: string | null
    set?: string | null
  },
) {
  if (options.id != null) {
    return `https://scryfall.com/cards/${options.id}`
  }

  if (options.set != null) {
    return `https://scryfall.com/search?q=%21%22${cardName}%22+e%3A${options.set}`
  }

  return `https://scryfall.com/search?q=%21%22${cardName}%22`
}
